import { DadosFaturamento } from "app/types/FaturamentoOutrasSaidas";
import { useFormik } from "formik";
import React, { useState } from "react";

const estiloFaturamento = require("./faturamento.module.scss").default;
const estiloFormulario = require('../../estilos/formulario.module.scss').default
const estiloBotoes = require('../../estilos/botoes.module.scss').default
const estilosInputs = require('../../estilos/inputs.module.scss').default


export type ErroFaturamento = {
    CodigoDepositoDestino?: string;
    CodigoMensagemTributaria?: string;
};

export type FaturamentoProps = {
    somenteLeitura: boolean
    dadosFaturamento: DadosFaturamento;
    onAplicar: (dados: DadosFaturamento) => void;
    onErrorValidacao: (erroFaturamento: ErroFaturamento) => void;
};

export const Faturamento = (props: FaturamentoProps) => {

    const [validado, setValidado] = useState(false);
    const formik = useFormik({
        initialValues: { ...props.dadosFaturamento },
        onSubmit: (values, { }) => { },
        enableReinitialize: true,
        validate: (values) => {
            const erros: ErroFaturamento = {};
            const mensagemObrigatorio = (campo) =>
                `O campo "${campo}" é obrigatório.`;
            values.MercadoriaComRetorno && values.CodigoDepositoDestino == ""
                ? (erros.CodigoDepositoDestino = mensagemObrigatorio("Depósito"))
                : null;
            formik.values.MercadoriaComRetorno == false && formik.values.OperacaoTributada == false && values.CodigoMensagemTributaria == ""
                ? (erros.CodigoMensagemTributaria = mensagemObrigatorio("Mensagem"))
                : null;
            return erros;
        }

    });

    const comRetorno = <>
        <label style={{ cursor: "pointer" }} htmlFor="orcTransferencia_Faturamento_ComRetorno">Com Retorno</label>
        <div className={estiloFaturamento.custom_container}>
            <input
                disabled={props.somenteLeitura}
                id="orcTransferencia_Faturamento_ComRetorno"
                type="checkbox"
                checked={formik.values.MercadoriaComRetorno ?? false}
                onChange={(e) => {
                    formik.setFieldValue("MercadoriaComRetorno", e.target.checked)
                    formik.setFieldValue("OperacaoTributada", e.target.checked ? false : true)
                    formik.setFieldValue("CodigoMensagemTributaria", ""),
                        formik.setFieldValue("CodigoDepositoDestino", "")
                }}
            />
        </div>
    </>

    const deposito = <>
        <label>Depósito {formik.values.MercadoriaComRetorno && <p className={estilosInputs.obrigatorio}>*</p>}</label>
        <select
            className={`_w-[300px] ${formik.values.MercadoriaComRetorno ? estiloFaturamento.select : estiloFaturamento.selectDisabled} 
            ${validado && formik.errors.CodigoDepositoDestino != undefined && formik.values.MercadoriaComRetorno == true ? estiloFaturamento.validador : null}`}
            name="CodigoDepositoDestino"
            onChange={formik.handleChange}
            value={(formik.values.CodigoDepositoDestino) ?? ""}
            disabled={!formik.values.MercadoriaComRetorno || props.somenteLeitura}
        >
            <option value=""></option>
            {props.dadosFaturamento?.Depositos?.map((deposito) => (
                <option key={deposito.Codigo} value={deposito.Codigo}>
                    {deposito.NomeFormatado}
                </option>
            ))}
        </select>
    </>

    const tributado = <>
        <label style={{ cursor: "pointer" }} htmlFor="orcTransferencia_Faturamento_Tributado">Tributado</label>
        <div className={estiloFaturamento.custom_container}>
            <input
              disabled={props.somenteLeitura}
                type="checkbox"
                id="orcTransferencia_Faturamento_Tributado"
                checked={formik.values.OperacaoTributada ?? false}
                onChange={(e) => {
                    formik.setFieldValue("OperacaoTributada", e.target.checked);
                    formik.setFieldValue("MercadoriaComRetorno", false)
                    formik.setFieldValue("CodigoDepositoDestino", "")
                    formik.setFieldValue("CodigoMensagemTributaria", "")
                }
                }
            />
        </div>
    </>
 
    const mensagem = <>
        <label>Mensagem{formik.values.MercadoriaComRetorno == false && formik.values.OperacaoTributada == false  && <p className={estilosInputs.obrigatorio}>*</p>}</label>
        <select
            className={`_w-[300px] ${formik.values.MercadoriaComRetorno == false && formik.values.OperacaoTributada == false ? estiloFaturamento.select : estiloFaturamento.selectDisabled}
                ${validado && formik.errors.CodigoMensagemTributaria != undefined && formik.values.MercadoriaComRetorno == false && formik.values.OperacaoTributada == false
                    ? estiloFaturamento.validador : null}`}
            name="CodigoMensagemTributaria"
            value={(formik.values.CodigoMensagemTributaria) ?? ""} 
            onChange={formik.handleChange}
            disabled={(formik.values.MercadoriaComRetorno == false && formik.values.OperacaoTributada == false ? false : true) || props.somenteLeitura}
        >
            <option value=""></option>
            {props.dadosFaturamento?.Mensagens?.map((mensagem) => (
                <option key={mensagem.Codigo} value={mensagem.Codigo}>
                    {mensagem.NomeFormatado}
                </option>
            ))}
        </select>
    </>

    const botaoAplicar = <>
        <div className={`no-global-button ${estiloFaturamento.buttonAbaEntrega}`}>
            <button
            className={estiloBotoes.botaoPrimario}
             onClick={() => {
                formik.validateForm(formik.values).then((onfulfilled) => {
                    Object.keys(onfulfilled).length == 0
                        ? props.onAplicar(formik.values)
                        : props.onErrorValidacao(onfulfilled);
                });
                setValidado(true);
            }}
            >
                Aplicar
            </button>
        </div>
    </>

    return (
        <>
            <div className={`_ml-24 _pt-8 ${estiloFormulario.formulario}`}>
                {comRetorno}

                {deposito}

                {tributado}

                {mensagem}
            </div>
            
            {!props.somenteLeitura && botaoAplicar}
        </>
    )
}

